import { FC, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BasicModal from '__components/Modals/presets/BasicModal';
import TextInput from '__components/Inputs/TextInput';
import LongText from '__components/Inputs/LongText';

export type WebhookData = {
  queryString: string;
  body: string;
};

type CreateWebhookModalProps = {
  onConfirm: (data: WebhookData) => void;
  onHide: () => void;
};

export const CreateWebhookModal: FC<CreateWebhookModalProps> = ({
  onConfirm,
  onHide,
}) => {
  const { t } = useTranslation();
  const [queryString, setQueryString] = useState('');
  const [body, setBody] = useState('');

  const handleSubmit = useCallback(() => {
    onConfirm({ queryString, body });
  }, [onConfirm, queryString, body]);

  return (
    <BasicModal
      size="medium"
      show
      onConfirm={handleSubmit}
      onHide={onHide}
      heading={t('Reference Data Settings')}
    >
      <TextInput
        label={t('Querystring')}
        placeholder={'?example=abc'}
        value={queryString}
        onChange={setQueryString}
        margin
      />
      <LongText
        label={t('Body')}
        placeholder={'{"key": "value"}'}
        value={body}
        onChange={setBody}
      />
    </BasicModal>
  );
};
